import { useState } from "react";
import styled from "styled-components";
import ActionButton from "../Shared/ActionButton";
import useFetchOrders from "../Shared/useFetchOrders";

const AnimatedText = ({ isAnimated, children }) => {
  return <span className={isAnimated ? 'animate' : ''}>
    <AnimatedTextStyled>{children}</AnimatedTextStyled>
  </span>
}
const AnimatedTextStyled = styled.div`
  .animate & {
    color: #0280c6;
    animation: 1s ease-in infinite alternate blink;
  }

  @keyframes blink {
    from {
      opacity: 1;
    }
  
    to {
      opacity: 0.3;
    }
  }
`

export const useDownloadOpportunity = () => {
  const { fetchOrdersExport: fetchOrdersExportHook } = useFetchOrders()

  return async (opportunity) => {
    fetchOrdersExportHook({ opportunityId: opportunity.Id, opportunityName: opportunity.Name })
  }
}

export default ({
  opportunity
}) => {
  const [isLoading, setIsLoading] = useState(false)

  const downloadOpportunity = useDownloadOpportunity()

  const onClick = async () => {
    setIsLoading(true)
    await downloadOpportunity(opportunity)
    setIsLoading(false)
  }

  return (
    <ActionButton onClick={onClick} $disabled={isLoading}>
      <AnimatedText isAnimated={isLoading}>Export</AnimatedText>
    </ActionButton>
  )
}